<script lang="ts" setup>
import { Groups } from '~~/server/api/insurance/assistance-services'

export interface PagesAssistanceServicesLinksProps {
    data: Groups
}

const props = defineProps<PagesAssistanceServicesLinksProps>()
</script>

<template>
  <section id="asistencna-sluzba-pre">
    <Tracker :data="{ position: props.data.title }">
      <Box color="gray-3">
        <BoxHeader
          heading-level="h2"
          :heading="props.data.title"
        />

        <ul class="row g-2 g-md-6 align-items-stretch">
          <li
            v-for="(group, groupIndex) in props.data.data"
            :key="`assistance-services-group-${groupIndex}`"
            class="col-12 col-md-3"
          >
            <Tracker :data="{ title: group.title }">
              <LinkBox
                :to="
                  useNamedRoutes({
                    name: 'assistance-services-detail',
                    params: { id: group.slug },
                  })
                "
                class="assistance-services-link h-100"
                class-names="rounded"
                :show-arrow="false"
                :label="
                  useNamedRoutes({
                    name: 'assistance-services-detail',
                    params: { id: group.slug },
                  })
                "
              >
                {{ group.title }}
              </LinkBox>
            </Tracker>
          </li>
        </ul>
      </Box>
    </Tracker>
  </section>
</template>

<style lang="scss" scoped>
@import './PagesAssistanceServicesLinks.scss';
</style>
